/**
 * @generated SignedSource<<05e39bcbf71a89c1699c08d2e7a4fcf9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VisibilityTreeConfigType = "VisibilityTree_AfterDateTime" | "VisibilityTree_Hide" | "VisibilityTree_HideForFachberater" | "VisibilityTree_NotAfterDateTime" | "VisibilityTree_OnlyAdmins" | "VisibilityTree_OnlyBasicSeminar" | "VisibilityTree_OnlyFachberater" | "VisibilityTree_OnlyFachrichtungen" | "VisibilityTree_OnlyIfTreeState" | "VisibilityTree_OnlyIfTreeStateOrAdmin" | "VisibilityTree_OnlySpecificPermissions" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment$data = {
  readonly configType?: VisibilityTreeConfigType;
  readonly fachrichtungen?: ReadonlyArray<string>;
  readonly id?: string;
  readonly " $fragmentType": "OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment";
};
export type OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment$key = {
  readonly " $data"?: OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "configType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fachrichtungen",
          "storageKey": null
        }
      ],
      "type": "OnlyFachrichtungenVisibilityTreeConfig",
      "abstractKey": null
    }
  ],
  "type": "VisibilityTreeConfig",
  "abstractKey": "__isVisibilityTreeConfig"
};

(node as any).hash = "346277df7b4890f07a919e1ea8bcfb28";

export default node;
